// Marketing event bridge — GTM dataLayer (Hawk container GTM-5HH4QGR,
// loaded in index.html). The scheduler pushes ONE event when a prospect
// booking is confirmed; every vendor tag (Meta pixel Schedule event,
// Microsoft UET, GA4, ...) is configured inside Tag Manager on this
// trigger — no per-vendor code here, no code deploy to add a tag.
//
// Fired from prospect-facing flows only (App.tsx qualifying flow +
// PersonalScheduler.tsx advisor links). Deliberately NOT fired from
// BookOnBehalfModal — that runs in a staff member's browser and would
// pollute ad-platform attribution.
//
// booking_id (when the response carries one) gives tags a stable
// dedup key (e.g. Meta eventID). No PII is pushed.

export function trackBookingConfirmed(res?: unknown): void {
  try {
    let bookingId = '';
    if (res && typeof res === 'object') {
      const r = res as Record<string, unknown>;
      const raw = r.bookingId ?? r.booking_id ?? r.id;
      if (typeof raw === 'string' || typeof raw === 'number') bookingId = String(raw);
    }
    const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({
      event: 'booking_confirmed',
      ...(bookingId ? { booking_id: bookingId } : {}),
    });
  } catch {
    // Tracking must never break a booking.
  }
}
